var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-center scoped-new-questioneditor" },
    [
      _vm.allowSwitchEditing && !_vm.loading
        ? _c(
            "div",
            { staticClass: "btn-group pull-right clear" },
            [
              _c("transition-group", { attrs: { name: "fade" } }, [
                _c(
                  "button",
                  {
                    key: "questionOverviewButton",
                    staticClass: "btn ",
                    class: _vm.editQuestion ? "btn-default" : "btn-primary",
                    attrs: { id: "questionOverviewButton" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.triggerEditQuestion(false)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("translate")("Question overview")) +
                        "\n            "
                    )
                  ]
                ),
                _c(
                  "button",
                  {
                    key: "questionEditorButton",
                    staticClass: "btn ",
                    class: _vm.editQuestion ? "btn-primary" : "btn-default",
                    attrs: { id: "questionEditorButton" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.triggerEditQuestion(true)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("translate")("Question editor")) +
                        "\n            "
                    )
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "pagetitle h3 scoped-unset-pointer-events" },
        [
          _vm.isCreateQuestion && !_vm.loading
            ? [
                _c("x-test", { attrs: { id: "action::addQuestion" } }),
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm._f("translate")(
                        _vm.initCopy ? "Copy question" : "Create question"
                      )
                    ) +
                    "\n        "
                )
              ]
            : _vm._e(),
          !_vm.isCreateQuestion && !_vm.loading
            ? [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm._f("translate")("Question")) +
                    ": " +
                    _vm._s(_vm.$store.state.currentQuestion.title) +
                    "  "
                ),
                _c("small", [
                  _vm._v(
                    "(ID: " + _vm._s(_vm.$store.state.currentQuestion.qid) + ")"
                  )
                ])
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "transition-group",
        { attrs: { name: "fade" } },
        [
          !_vm.loading
            ? [
                _vm.initCopy
                  ? _c(
                      "div",
                      { key: "questioncopy-block", staticClass: "row" },
                      [
                        _c(
                          "div",
                          { staticClass: "form-group col-lg-3 col-sm-6" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "ls-space margin right-5",
                                attrs: { for: "copySubquestions" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("translate")("Copy subquestions")
                                  )
                                )
                              ]
                            ),
                            _vm.initCopy
                              ? _c("bootstrap-toggle", {
                                  key: "el-copySubquestions",
                                  attrs: {
                                    id: "copySubquestions",
                                    options: _vm.switcherOptions
                                  },
                                  model: {
                                    value: _vm.copySubquestions,
                                    callback: function($$v) {
                                      _vm.copySubquestions = $$v
                                    },
                                    expression: "copySubquestions"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "form-group col-lg-3 col-sm-6" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "ls-space margin right-5",
                                attrs: { for: "copyAnswerOptions" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("translate")("Copy answer options")
                                  )
                                )
                              ]
                            ),
                            _vm.initCopy
                              ? _c("bootstrap-toggle", {
                                  key: "el-copyAnswerOptions",
                                  attrs: {
                                    id: "copyAnswerOptions",
                                    options: _vm.switcherOptions
                                  },
                                  model: {
                                    value: _vm.copyAnswerOptions,
                                    callback: function($$v) {
                                      _vm.copyAnswerOptions = $$v
                                    },
                                    expression: "copyAnswerOptions"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "form-group col-lg-3 col-sm-6" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "ls-space margin right-5",
                                attrs: { for: "copyDefaultAnswers" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("translate")("Copy default answers")
                                  )
                                )
                              ]
                            ),
                            _vm.initCopy
                              ? _c("bootstrap-toggle", {
                                  key: "el-copyDefaultAnswers",
                                  attrs: {
                                    id: "copyDefaultAnswers",
                                    options: _vm.switcherOptions
                                  },
                                  model: {
                                    value: _vm.copyDefaultAnswers,
                                    callback: function($$v) {
                                      _vm.copyDefaultAnswers = $$v
                                    },
                                    expression: "copyDefaultAnswers"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "form-group col-lg-3 col-sm-6" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "ls-space margin right-5",
                                attrs: { for: "copyAdvancedOptions" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("translate")("Copy advanced options")
                                  )
                                )
                              ]
                            ),
                            _vm.initCopy
                              ? _c("bootstrap-toggle", {
                                  key: "el-copyAdvancedOptions",
                                  attrs: {
                                    id: "copyAdvancedOptions",
                                    options: _vm.switcherOptions
                                  },
                                  model: {
                                    value: _vm.copyAdvancedOptions,
                                    callback: function($$v) {
                                      _vm.copyAdvancedOptions = $$v
                                    },
                                    expression: "copyAdvancedOptions"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _c("div", { key: "questioncode-block", staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "form-group col-sm-6 scoped-responsive-fix-height"
                    },
                    [
                      _c("label", { attrs: { for: "questionCode" } }, [
                        _vm._v(_vm._s(_vm._f("translate")("Code")))
                      ]),
                      _c(
                        "div",
                        { staticClass: "scoped-keep-in-line" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.currentQuestionCode,
                                expression: "currentQuestionCode"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              text: "text",
                              id: "questionCode",
                              maxlength: this.maxQuestionCodeLength,
                              required: true,
                              readonly: !(
                                _vm.editQuestion ||
                                _vm.isCreateQuestion ||
                                _vm.initCopy
                              )
                            },
                            domProps: { value: _vm.currentQuestionCode },
                            on: {
                              dblclick: _vm.triggerEditQuestion,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.currentQuestionCode = $event.target.value
                              }
                            }
                          }),
                          _c("type-counter", {
                            attrs: {
                              countable: _vm.currentQuestionCode.length,
                              "max-value": this.maxQuestionCodeLength,
                              valid: _vm.inputValid
                            }
                          })
                        ],
                        1
                      ),
                      _vm.noCodeWarning != null
                        ? _c(
                            "p",
                            { staticClass: "well bg-warning scoped-highten-z" },
                            [_vm._v(_vm._s(_vm.noCodeWarning))]
                          )
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "form-group col-sm-6 contains-question-selector"
                    },
                    [
                      _c("label", { attrs: { for: "questionCode" } }, [
                        _vm._v(_vm._s(_vm._f("translate")("Question type")))
                      ]),
                      _vm.$store.getters.surveyObject.active !== "Y"
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editQuestion || _vm.isCreateQuestion,
                                  expression:
                                    "(editQuestion || isCreateQuestion)"
                                }
                              ],
                              staticClass: "btn-group"
                            },
                            [
                              _vm.useModalSelector
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: {
                                        id: "trigger_question_selector_button",
                                        type: "button",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false"
                                      },
                                      on: {
                                        click: _vm.toggleQuestionTypeSelector
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-folder-open"
                                      }),
                                      _vm._v(
                                        "  \n                            "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "buttontext",
                                          attrs: {
                                            id:
                                              "selector__questionType_selector--buttonText"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.currentQuestionTypeDescription
                                              ) +
                                              "\n                                "
                                          ),
                                          _c("em", { staticClass: "small" }, [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm._f("translate")("Type:")
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.$store.state
                                                    .currentQuestion.type
                                                ) +
                                                "\n                                "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              !_vm.useModalSelector
                                ? _c("SimpleQuestionTypeSelector", {
                                    attrs: {
                                      id: "simplequestionselector",
                                      debug: true
                                    },
                                    on: { triggerEvent: _vm.triggerEvent }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(
                              (_vm.editQuestion || _vm.isCreateQuestion) &&
                              _vm.$store.getters.surveyObject.active !== "Y"
                            ),
                            expression:
                              "!((editQuestion || isCreateQuestion) && $store.getters.surveyObject.active !=='Y')"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "questionTypeVisual",
                          readonly: true
                        },
                        domProps: {
                          value:
                            _vm.$store.state.currentQuestion.typeInformation
                              .description +
                            " (" +
                            _vm.$store.state.currentQuestion.type +
                            ")"
                        }
                      }),
                      _vm.$store.getters.surveyObject.active !== "Y"
                        ? _c("input", {
                            attrs: {
                              type: "hidden",
                              id: "question_type",
                              name: "type"
                            },
                            domProps: {
                              value: _vm.$store.state.currentQuestion.type
                            }
                          })
                        : _vm._e()
                    ]
                  )
                ]),
                this.containsMultipleLanguages
                  ? _c(
                      "div",
                      { key: "languageselector-block", staticClass: "row" },
                      [
                        _c("languageselector", {
                          attrs: {
                            elId: "question-language-changer",
                            aLanguages: _vm.$store.state.languages,
                            parentCurrentLanguage:
                              _vm.$store.state.activeLanguage
                          },
                          on: { change: _vm.selectLanguage }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { key: "editorcontent-block", staticClass: "col-12" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "ls-flex ls-flex-row scope-create-gutter"
                      },
                      [
                        _c(
                          "transition",
                          { attrs: { name: "slide-fade-left" } },
                          [
                            _c("maineditor", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editQuestion || _vm.isCreateQuestion,
                                  expression:
                                    "(editQuestion || isCreateQuestion)"
                                }
                              ],
                              attrs: { loading: _vm.loading, event: _vm.event },
                              on: {
                                triggerEvent: _vm.triggerEvent,
                                eventSet: _vm.eventSet
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "transition",
                          { attrs: { name: "slide-fade-left" } },
                          [
                            _c("questionoverview", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !(
                                    _vm.editQuestion || _vm.isCreateQuestion
                                  ),
                                  expression:
                                    "!(editQuestion || isCreateQuestion)"
                                }
                              ],
                              attrs: { loading: _vm.loading, event: _vm.event },
                              on: {
                                triggerEvent: _vm.triggerEvent,
                                eventSet: _vm.eventSet
                              }
                            })
                          ],
                          1
                        ),
                        _c("generalsettings", {
                          attrs: {
                            event: _vm.event,
                            readonly: !(
                              _vm.editQuestion || _vm.isCreateQuestion
                            )
                          },
                          on: {
                            triggerEvent: _vm.triggerEvent,
                            eventSet: _vm.eventSet
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "ls-flex ls-flex-row scoped-advanced-settings-block"
                      },
                      [
                        _c("advancedsettings", {
                          attrs: {
                            event: _vm.event,
                            readonly: !(
                              _vm.editQuestion || _vm.isCreateQuestion
                            ),
                            "hide-advanced-options":
                              _vm.initCopy && _vm.copyAdvancedOptions,
                            "hide-subquestions":
                              _vm.initCopy && _vm.copyAdvancedOptions,
                            "hide-answeroptions":
                              _vm.initCopy && _vm.copyAdvancedOptions
                          },
                          on: {
                            triggerEvent: _vm.triggerEvent,
                            eventSet: _vm.eventSet
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.loading
            ? _c("loader-widget", { attrs: { id: "mainViewLoader" } })
            : _vm._e()
        ],
        1
      ),
      _c("modals-container", { on: { modalEvent: _vm.setModalEvent } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }